import { localize } from 'VeeValidate';

export default function setupValidation(language, validationMessages) {
    //setup error messages
    var loc = {};
    loc[language] = {};
    loc[language]["messages"] = JSON.parse(validationMessages);
    localize(loc);
    localize(language); //now set the language
}